 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Bund~analytics~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~mem~e67ed452":"Bund~analytics~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~mem~e67ed452","Bund~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~members~myclu~75548f5b":"Bund~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~members~myclu~75548f5b","Bund":"Bund","about~massmail":"about~massmail","massmail":"massmail","authorization":"authorization","clubWeaponpool":"clubWeaponpool","clubs":"clubs","contributionGroups":"contributionGroups","education":"education","feedback":"feedback","members~schiessleiterToday~shootingbook~today~workinghoursEvaluation":"members~schiessleiterToday~shootingbook~today~workinghoursEvaluation","members~shootingbook~workinghoursEvaluation":"members~shootingbook~workinghoursEvaluation","members":"members","shootingbook":"shootingbook","workinghoursEvaluation":"workinghoursEvaluation","schiessleiterToday~today":"schiessleiterToday~today","schiessleiterToday":"schiessleiterToday","today":"today","myclub":"myclub","profil~weapon":"profil~weapon","recordtime~weapon":"recordtime~weapon","weapon":"weapon","ranges":"ranges","recordtime":"recordtime","terminal":"terminal","userAssignments":"userAssignments","userWeaponpool":"userWeaponpool","userWeaponpoolMine":"userWeaponpoolMine","users":"users","verbaende":"verbaende","verband":"verband","welcome":"welcome","workingHoursList":"workingHoursList","workinghoursApprovals":"workinghoursApprovals","workinghoursAssignments":"workinghoursAssignments","workinghoursFunctions":"workinghoursFunctions","analytics":"analytics","profil":"profil","recordWorkingHours":"recordWorkingHours","about":"about","changePassword":"changePassword","clubWeaponpoolStatistics":"clubWeaponpoolStatistics","disciplines":"disciplines","legal":"legal","login":"login","register":"register","uwelcome":"uwelcome","vwelcome":"vwelcome"}[chunkId]||chunkId) + "." + {"Bund~analytics~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~mem~e67ed452":"de5fd18b","Bund~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~members~myclu~75548f5b":"47a6938b","Bund":"4ee1acfc","about~massmail":"b6847a9f","massmail":"34ad17cd","authorization":"16c0b2b8","clubWeaponpool":"3a522b35","clubs":"3b211486","contributionGroups":"7ca730d5","education":"25f7e3ba","feedback":"567f1226","members~schiessleiterToday~shootingbook~today~workinghoursEvaluation":"a3aa1ff9","members~shootingbook~workinghoursEvaluation":"ba56b44c","members":"b8449683","shootingbook":"8c9a212d","workinghoursEvaluation":"bb04bda5","schiessleiterToday~today":"dbe88c30","schiessleiterToday":"90901d61","today":"66b8ea3a","myclub":"3e243185","profil~weapon":"6c3f8507","recordtime~weapon":"52b8f6ed","weapon":"2b0ac719","ranges":"7988b3df","recordtime":"353926d6","terminal":"4c9cdb39","userAssignments":"b9c34814","userWeaponpool":"b7ff09ba","userWeaponpoolMine":"35aad71f","users":"358432ce","verbaende":"a9e9d6a1","verband":"855e3409","welcome":"484051db","workingHoursList":"3d604b36","workinghoursApprovals":"a8048113","workinghoursAssignments":"078af147","workinghoursFunctions":"30a7b835","analytics":"28b3d04e","profil":"caa4f7d5","recordWorkingHours":"efd17bde","about":"4216692a","changePassword":"2140d8a4","clubWeaponpoolStatistics":"a57ee1c9","disciplines":"46c2858e","legal":"04f6e710","login":"c071c338","register":"84e6d055","uwelcome":"b80b15f6","vwelcome":"0207204a","chunk-2d216214":"4a9288c8","chunk-2d216257":"69e90091","chunk-7bdcecb4":"af74aa27"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Bund~analytics~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~mem~e67ed452":1,"Bund~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~members~myclu~75548f5b":1,"about~massmail":1,"authorization":1,"clubWeaponpool":1,"contributionGroups":1,"members":1,"shootingbook":1,"workinghoursEvaluation":1,"today":1,"myclub":1,"recordtime~weapon":1,"weapon":1,"ranges":1,"recordtime":1,"terminal":1,"userWeaponpool":1,"userWeaponpoolMine":1,"welcome":1,"workingHoursList":1,"workinghoursApprovals":1,"workinghoursAssignments":1,"workinghoursFunctions":1,"analytics":1,"clubWeaponpoolStatistics":1,"disciplines":1,"legal":1,"login":1,"register":1,"uwelcome":1,"vwelcome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Bund~analytics~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~mem~e67ed452":"Bund~analytics~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~mem~e67ed452","Bund~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~members~myclu~75548f5b":"Bund~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~members~myclu~75548f5b","Bund":"Bund","about~massmail":"about~massmail","massmail":"massmail","authorization":"authorization","clubWeaponpool":"clubWeaponpool","clubs":"clubs","contributionGroups":"contributionGroups","education":"education","feedback":"feedback","members~schiessleiterToday~shootingbook~today~workinghoursEvaluation":"members~schiessleiterToday~shootingbook~today~workinghoursEvaluation","members~shootingbook~workinghoursEvaluation":"members~shootingbook~workinghoursEvaluation","members":"members","shootingbook":"shootingbook","workinghoursEvaluation":"workinghoursEvaluation","schiessleiterToday~today":"schiessleiterToday~today","schiessleiterToday":"schiessleiterToday","today":"today","myclub":"myclub","profil~weapon":"profil~weapon","recordtime~weapon":"recordtime~weapon","weapon":"weapon","ranges":"ranges","recordtime":"recordtime","terminal":"terminal","userAssignments":"userAssignments","userWeaponpool":"userWeaponpool","userWeaponpoolMine":"userWeaponpoolMine","users":"users","verbaende":"verbaende","verband":"verband","welcome":"welcome","workingHoursList":"workingHoursList","workinghoursApprovals":"workinghoursApprovals","workinghoursAssignments":"workinghoursAssignments","workinghoursFunctions":"workinghoursFunctions","analytics":"analytics","profil":"profil","recordWorkingHours":"recordWorkingHours","about":"about","changePassword":"changePassword","clubWeaponpoolStatistics":"clubWeaponpoolStatistics","disciplines":"disciplines","legal":"legal","login":"login","register":"register","uwelcome":"uwelcome","vwelcome":"vwelcome"}[chunkId]||chunkId) + "." + {"Bund~analytics~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~mem~e67ed452":"80e16129","Bund~authorization~clubWeaponpool~clubs~contributionGroups~education~feedback~massmail~members~myclu~75548f5b":"daca5a6e","Bund":"31d6cfe0","about~massmail":"02d3ac74","massmail":"31d6cfe0","authorization":"c1e3b5f8","clubWeaponpool":"dfd1e988","clubs":"31d6cfe0","contributionGroups":"1fb04e29","education":"31d6cfe0","feedback":"31d6cfe0","members~schiessleiterToday~shootingbook~today~workinghoursEvaluation":"31d6cfe0","members~shootingbook~workinghoursEvaluation":"31d6cfe0","members":"445afc82","shootingbook":"2b49bd53","workinghoursEvaluation":"950381b3","schiessleiterToday~today":"31d6cfe0","schiessleiterToday":"31d6cfe0","today":"78bd0e90","myclub":"c318e65e","profil~weapon":"31d6cfe0","recordtime~weapon":"bf809f5e","weapon":"52b229eb","ranges":"97492890","recordtime":"85c3b04e","terminal":"54991f3b","userAssignments":"31d6cfe0","userWeaponpool":"4eb0deb2","userWeaponpoolMine":"e0441376","users":"31d6cfe0","verbaende":"31d6cfe0","verband":"31d6cfe0","welcome":"e0a0fd75","workingHoursList":"4eb0deb2","workinghoursApprovals":"fedd3d63","workinghoursAssignments":"41b44d1a","workinghoursFunctions":"950381b3","analytics":"636f7801","profil":"31d6cfe0","recordWorkingHours":"31d6cfe0","about":"31d6cfe0","changePassword":"31d6cfe0","clubWeaponpoolStatistics":"2392e091","disciplines":"2b617eff","legal":"4f6ef88b","login":"ce2f2872","register":"fd12b997","uwelcome":"59af45af","vwelcome":"59af45af","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-7bdcecb4":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
